import React, { useRef, useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { useOnScreen } from '../../../utils/hooks';
import { urlify } from '../../../utils/string';
import s from './Heading.scss';

const Heading = ({ content, attrs = {} }) => {
	const headingContainer = useRef(null);
	const isVisible = useOnScreen(headingContainer, { threshold: 1.0 });
	const initialText = content.rawText.replace(/\d+%/g, '0%');
	const [headingText, updateHeadingText] = useState(initialText);

	const style = {};
	const HeadingTag = `h${content?.level || '2'}`;
	let headingClasses = [s.heading];
	if (attrs.className) headingClasses = [...headingClasses, ...attrs.className.map((cN) => s[`heading${cN}`])];
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textAlign) style.textAlign = attrs.textAlign;
	if (/\d+%$/.test(content.rawText)) {
		headingClasses = [...headingClasses, s.heading__percentage];
	}

	useEffect(() => {
		let percentageAnimation = false;
		let counter = 0;

		if (/\d+%$/.test(content.rawText) && !percentageAnimation && isVisible) {
			percentageAnimation = setInterval(() => {
				counter += 1;
				if (counter <= parseInt(content.rawText.replace(/[^\d]+/g, ''), 10)) updateHeadingText(content.rawText.replace(/\d+%/g, `${counter}%`));
				else clearInterval(percentageAnimation);
			}, 10);
		}

		return () => {
			if (percentageAnimation && counter > parseInt(content.rawText, 10)) {
				clearInterval(percentageAnimation);
			}
		};
	}, [isVisible]);

	return (
		<div id={urlify(content.rawText)} className={headingClasses.join(' ')} style={style} ref={headingContainer}>
			<HeadingTag className={[s.heading_inner, (attrs.fontSize ? `u_fontSize__${attrs.fontSize}` : null)].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(headingText) }} />
		</div>
	);
};

export default hot(module)(Heading);
